export const authRoles = {
  admin: ["ADMIN"], // Only SA & Admin has access
  adminhr: ["ADMIN", "HR"],
  accounting: ["ACCOUNTING"],
  hr: ["HR"], // Only SA & Admin has access
  approver: ["APPROVER"], // Only SA & Admin & Editor has access
  user: ["ADMIN", "APPROVER", "USER", "HR", "ACCOUNTING"], // Everyone has access
};
